<div class="card-fit">
  <h5 *ngIf="selectedFolder&&!previewMedium?.uploaded" class="red font-weight-bold">
    {{ 'lang.mediumExplorer.folder'| translate : { folder: selectedFolder.name } }}
  </h5>
  <div class="card-img fill border-bottom" style="height: 17rem">
    <div class="w-100 h-100 d-flex align-items-center justify-content-center">
      <div (dragenter)="isDragOver = true"
           (dragleave)="isDragOver = false"
           (dragover)="dragOverHandler($event)"
           (drop)="isDragOver = false; dropHandler.emit($event);"
           *ngIf="!previewMedium && !isInModalContext || modalType === 'upload'"
           [ngClass]="{
                    'box-dragover': (!previewMedium && !isInModalContext || modalType === 'upload') && isDragOver,
                    'box-dragdrop': !previewMedium && (!previewMedium && !isInModalContext || modalType === 'upload')
                }"
           class="w-100 h-100 d-flex align-items-center justify-content-center"
           id="dropzone">
        <h5>{{ 'lang.mediumExplorer.dragDropFiles' | translate }}</h5>
      </div>
      <div *ngIf="previewMedium?.contentType && !previewMedium?.processing && !previewMedium?.uploading"
           [@fadeInOut]>
        <sb-comp-medium [customHeight]="'100%'" [customWidth]="'100%'" [medium]="previewMedium"
                        [showFullOnClick]="true"
                        [thumbnailSize]="'L'" [title]="true" style="width: 100%"></sb-comp-medium>
      </div>
      <h5 *ngIf="previewMedium?.uploading">
        <sb-icon icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}" [style.color]="'#004F90'"
                 class="mr-2">
        </sb-icon>
        {{ 'lang.mediumExplorer.uploading' | translate }}
      </h5>
      <h5 *ngIf="previewMedium?.processing">
        <sb-icon icon="loadingCircleAnimation" [animationOptions]="{autoplay: true, loop:true}" [style.color]="'#004F90'"
                 class="mr-2">
        </sb-icon>
        {{ 'lang.mediumExplorer.processing' | translate }}
      </h5>
    </div>
  </div>
  <div *ngIf="!previewMedium && !isInModalContext || modalType === 'upload'"
       class="px-4 pb-4 pt-0 d-flex justify-content-center align-items-center flex-column">
    <h5>{{ 'lang.globals.or' | translate }}</h5>
    <button (click)="openFilePicker.emit()" class="btn btn-primary ">
      <sb-icon icon="upload"></sb-icon>&nbsp;{{ 'lang.mediumExplorer.uploadFiles' | translate }}
    </button>
  </div>
  <!-- TODO ContentEditor
  <ng-container
    *ngPermissions="[permissionService.Permission.template_store_data_create, permissionService.Permission.template_store_list]">
    <div *ngIf="!previewMedium && !isInModalContext || modalType === 'upload'"
         class="px-4 pb-4 pt-0 d-flex justify-content-center align-items-center flex-column">
      <h5>{{'lang.globals.or' | translate}}</h5>
      <a [sbRouterLink]="util.RoutingID.contentEditor" class="">
        <button class="btn btn-primary ">
          <sb-icon icon="plus"></sb-icon>&nbsp;{{'nav.contentEditor.createContent' | translate}}
        </button>
      </a>
    </div>
  </ng-container>
  -->
  <div *ngIf="!previewMedium && (!isInModalContext || modalType === 'upload')"
       class="px-4 pb-4 pt-0 d-flex justify-content-center align-items-center flex-column">
    <ng-container *ngPermissions="permissionService.Permission.company_list">
      <label class="form-label" for="PreSelectCompany">{{ 'lang.globals.company' | translate }}</label>
      <div container="body" ngbTooltip="{{preselectedCompany ? ('lang.globals.companyIsPreselected' | translate) :''}}">
        <button (click)="preSelectCompany.emit()" class="btn btn-secondary  text-center"
                id="PreSelectCompany" [disabled]="preselectedCompany"
                type="button">
          <sb-icon class="mr-1" icon="company"></sb-icon>
          {{ preselectedCompany ? stringTransformation.locationOrCompanyToShortString(preselectedCompany) : ('lang.globals.default'|translate) }}
        </button>
      </div>
    </ng-container>
  </div>
  <div *ngIf="previewMedium && !previewMedium.processing && !previewMedium.uploading && previewMedium.uploaded"
       [@fadeInOut]
       class="p-3">
    <div class="row">
      <div class="col-12 mb-3">
        <small *ngIf="!previewMedium.locked && previewMedium.usageCount === 0" class="red">
          <sb-icon icon="lockOpen"></sb-icon>&nbsp;&nbsp;{{
            'lang.mediumExplorer.notReadyUse'
              | translate
          }}
        </small>
        <small *ngIf="previewMedium.locked && previewMedium.usageCount === 0" class="yellow">
          <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{
            'lang.mediumExplorer.readyUse' |
              translate
          }}
        </small>
        <small *ngIf="previewMedium && previewMedium.usageCount >= 1" class="green">
          <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.inUse' | translate }}
          ({{ previewMedium?.usageCount }} {{ previewMedium?.usageCount > 1 ? 'times' : 'time' }})
        </small>
      </div>
    </div>
    <!-- medium swap -->
    <div class="form-group mb-1 d-block">
      <div class="d-flex justify-content-between mb-2">
        <button
          (click)="openFileReplacePicker.emit(previewMedium)"
          *ngIf="!previewMedium.assetFile && !previewMedium.locked && !previewMedium.templateStoreData && permissionService.hasPermission(permissionService.Permission.medium_upload)"
          class="btn btn-primary w-100 mr-1">
          {{ 'lang.mediumExplorer.mediumChange' | translate }}
        </button>
        <a
          [download]="previewMedium.fileName"
          [ngClass]="{'ml-1': !previewMedium.locked && !previewMedium.templateStoreData && permissionService.hasPermission(permissionService.Permission.medium_upload)}"
          class="btn btn-default w-100" href="{{previewMedium?.url}}"
          rel="noopener noreferrer" target="_blank">
          <sb-icon icon="download"></sb-icon>
          {{ 'lang.mediumExplorer.downloadMedium' | translate }}
        </a>
      </div>
      <!-- TODO Contenteditor?
      <ng-container *ngPermissions="permissionService.Permission.template_store_data_edit">
        <div *ngIf="previewMedium?.templateStoreData?.id" class="d-flex justify-content-between mb-2">
          <a [pathParams]="[{id: 'mediumID', value: previewMedium?.id}]"
             [sbRouterLink]="util.RoutingID.contentEditorEditContent"
             class="btn btn-default w-100">
            <sb-icon icon="edit"></sb-icon>&nbsp;{{'lang.mediumExplorer.editMedium' | translate}}
          </a>
        </div>
      </ng-container>
      -->
      <label class="form-label" *ngIf="!previewMedium.locked" for="Title">
        {{ 'lang.mediumExplorer.title' | translate }}
      </label>
      <input (blur)="mediumNameChanged.emit(previewMedium)" *ngIf="!previewMedium.locked"
             [ngModel]="previewMedium && previewMedium.name" (ngModelChange)="previewMedium && (previewMedium.name = $event)"
             [disabled]="!permissionService.hasPermission(permissionService.Permission.medium_edit)" class="form-control" id="Title"
             type="text">
    </div>
    <div *ngIf="!previewMedium.locked" class="form-group my-1">
      <div class="d-flex justify-content-between mb-2 w-100">
        <button
          (click)="selectCompany.emit(previewMedium)"
          *ngIf="!selectedCompany"
          [disabled]="!permissionService.hasPermission(permissionService.Permission.medium_edit) || !permissionService.hasPermission(permissionService.Permission.company_list)"
          class="btn btn-secondary w-100"
          id="Company">
          <sb-icon class="mr-1" icon="company"></sb-icon>
          {{ previewMedium?.company?.name ? previewMedium.company.name : 'unknown company' }}
        </button>
      </div>
      <div ngbTooltip="{{'lang.globals.companyIsPreselected' | translate}}" container="body">
        <button (click)="preSelectCompany.emit()" *ngIf="selectedCompany" [attr.disabled]="'disabled'"
                class="btn btn-secondary w-100" type="button">
          <sb-icon class="mr-1" icon="company"></sb-icon>
          {{ preselectedCompany ? stringTransformation.locationOrCompanyToShortString(preselectedCompany) : ('lang.globals.default'|translate) }}
        </button>
      </div>
    </div>
    <div *ngIf="!previewMedium.locked && previewMedium.uploaded"
         class="d-flex justify-content-between mb-2">
      <button (click)="lockMedium.emit(previewMedium)" *ngPermissions="permissionService.Permission.medium_lock"
              class="btn btn-success w-100 mr-1">
        <sb-icon icon="lockClosed"></sb-icon>
        {{ 'lang.mediumExplorer.setReady' | translate }}
      </button>
      <button (click)="deleteMedium.emit(previewMedium)" *ngPermissions="permissionService.Permission.medium_delete"
              class=" btn btn-danger w-100 ml-1">
        <sb-icon icon="trash"></sb-icon>
        {{ 'lang.mediumExplorer.delete' | translate }}
      </button>
    </div>
    <ng-container *ngPermissions="permissionService.Permission.medium_group_show">
      <ng-container *ngIf="previewMedium?.locked && previewMedium?.mediumGroup && !isInModalContext">
        <div class="my-2">{{ 'lang.globals.mediumGroup'|translate }}</div>
        <!--mediumComplete-->
        <div class="tw-p-2 tw-py-4 tw-border-solid tw-border tw-rounded-md tw-w-full">

          <a
            class="tw-inline-flex tw-gap-2"
            [sbRouterLink]="util.RoutingID.mediumGroupEdit"
            [pathParams]="[{id: 'mediumGroupID', value: previewMedium?.mediumGroup?.id}]"
            [ngbTooltip]="'lang.mediumExplorer.switchMediumgroup' | translate"
            container="body"
          >
            <sb-icon icon="motives"></sb-icon>
            <div>
              {{ previewMedium?.mediumGroup?.name }}
            </div>
          </a>
        </div>
        <!-- <div class="d-flex">
            <a [download]="previewMedium?.name" class="btn btn-default "
                [href]="'/api/File/' + previewMedium.url.data">
                <fa-icon icon="download"></fa-icon>
                {{'lang.mediumExplorer.downloadMedium' | translate}}
            </a>
        </div> -->
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="previewMedium && !previewMedium.processing && !previewMedium.uploaded && !previewMedium.locked"
       class="p-3">
    <div *ngPermissions="permissionService.Permission.medium_upload"
         class="pt-1 d-flex justify-content-center align-items-center flex-column">
      <button (click)="openFileReplacePicker.emit(previewMedium)" *ngIf="!previewMedium.assetFile && !previewMedium.templateStoreData"
              class="btn btn-primary ">
        <sb-icon icon="refresh"></sb-icon>&nbsp;{{
          'lang.mediumExplorer.mediumChange' |
            translate
        }}
      </button>
    </div>
    <div class="pt-1 d-flex justify-content-center align-items-center flex-column">
      <button (click)="deleteMedium.emit(previewMedium)" *ngPermissions="permissionService.Permission.medium_delete"
              class=" btn btn-danger w-100">
        <sb-icon icon="trash"></sb-icon>
        {{ 'lang.mediumExplorer.delete' | translate }}
      </button>
    </div>
    <!-- TODO contenteditor ?
    <ng-container *ngPermissions="permissionService.Permission.template_store_data_edit">
      <div *ngIf="previewMedium?.templateStoreData?.id" class="d-flex justify-content-between mb-2">
        <a [pathParams]="[{id: 'mediumID', value: previewMedium?.id}]"
           [sbRouterLink]="util.RoutingID.contentEditorEditContent"
           class="btn btn-default w-100">>
          <sb-icon icon="edit"></sb-icon>&nbsp;{{'lang.mediumExplorer.editMedium' | translate}}
        </a>
      </div>
    </ng-container>
    -->
  </div>

  <div *ngIf="previewMedium && !previewMedium.processing && !previewMedium.uploading" [@fadeInOut] class="p-3">
    <button (click)="addMediumToBooking.emit(previewMedium)"
            *ngIf="isInModalContext && modalType === 'bookingSelect' && previewMedium?.locked"
            class="btn btn-primary ">{{ 'lang.mediumExplorer.selectMedium' | translate }}
    </button>
    <div *ngIf="isInModalContext && modalType === 'groupSelect' && previewMedium.locked" class="row">
      <div class="col-12 mt-3">
        <sb-button (click)="toggleMediumSelection.emit(previewMedium)"
                   *ngIf="!(previewMedium['excluded'])" classes="btn-primary mb-2 ">
          {{
            !isMediumInSelectedMedias(previewMedium) ? ('lang.mediumExplorer.addToSelection' |
              translate) : ('lang.mediumExplorer.removeFromSelection' | translate)
          }}
        </sb-button>
      </div>
    </div>
    <ng-container *ngIf="previewMedium.promotedProducts?.length>0">
      {{ 'lang.globals.products'|translate }}: {{ getPromotedProductsText() }}
    </ng-container>
    @if (previewMedium?.contentType === 'text/html') {
      <div class="my-2">{{ 'lang.globals.templateGroup'|translate }}</div>
      <sb-comp-selection [display]="previewMedium?.templateGroup"
                         [hideCreate]="true"
                         [hideAll]="previewMedium?.locked"
                         (selectClicked)="selectTemplateGroup.emit(previewMedium)"
                         (deleteClicked)="deleteTemplateGroup.emit(previewMedium)">
      </sb-comp-selection>
      <button (click)="showTemplatePreview.emit(previewMedium)"
              [disabled]="!previewMedium?.templateGroup"
              class="btn btn-primary w-100 tw-mt-2">{{ 'lang.globals.showTemplatePreview' | translate }}
      </button>
    }
    <h4 class="mb-2 mt-3">{{ 'lang.mediumExplorer.info' | translate }}</h4>
    <ng-container *ngIf="previewMedium.locked">
      <div class="d-flex justify-content-between mb-2 font-weight-bold">
        <span>{{ 'lang.mediumExplorer.title' | translate }}</span>
        <span [innerHTML]="previewMedium?.name | truncate : 35"></span>
      </div>
      <div class="d-flex justify-content-between mb-4 font-weight-bold">
        <span>{{ 'lang.globals.company' | translate }}</span>
        <span>{{ previewMedium?.company?.name ? previewMedium?.company?.name : ('lang.globals.unknown.company' |translate) }}</span>
      </div>
    </ng-container>

    <div class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.headlines.folder' | translate }}</span>
      <span>{{ previewMedium?.folder?.name ?? '-' }}</span>
    </div>
    <div [class.red]="displayNoMatchingMarker()" container="body"
         [ngbTooltip]="displayNoMatchingMarker()? ('lang.globals.noMatchingResolution' | translate) : null"
         class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.globals.resolution' | translate }}</span>
      <div>
        <span>{{ previewMedium?.resolution?.id ? previewMedium?.resolution?.id : ('lang.globals.unknown.resolution' |translate) }}</span>
        <sb-icon *ngIf="displayNoMatchingMarker()" class="red" icon="attention"></sb-icon>
      </div>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.mediumExplorer.duration' | translate }}</span>
      <span>{{ previewMedium?.duration ? previewMedium?.duration + 's' : ('lang.globals.unknown.duration' |translate) }}</span>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.mediumExplorer.fileFormat' | translate }}</span>
      <span>{{ previewMedium?.contentType ? previewMedium?.contentType : ('lang.globals.unknown.contentType' |translate) }}</span>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.globals.modifiedAt' | translate }}</span>
      <span>{{ previewMedium?.createdAt?.value ? util.dateToDateTimeString(previewMedium.createdAt.value) : ('lang.globals.unknown' |translate) }}</span>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.globals.modifiedByCreator' | translate }}</span>
      <span>{{ previewMedium?.createdBy?.name ? previewMedium.createdBy.name : ('lang.globals.unknown.creator' |translate) }}</span>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>{{ 'lang.globals.filesize' | translate }}</span>
      <span>{{ previewMedium?.size ? util.formatBytes(previewMedium.size) : ('lang.globals.unknown' |translate) }}</span>
    </div>
    <div class="d-flex justify-content-between mb-2" *ngIf="previewMedium?.id">
      <span>ID</span>
      <span>{{ previewMedium?.id }}</span>
    </div>
    <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [(tags)]="previewMedium.tags"
             [dtoId]="previewMedium.id" [dtoType]="tagService.TaggableDTO.Medium"></sb-tags>
  </div>
</div>
